let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1ucv3")).then(() => parcelRequire('5a4B6'));